const customerRoutes = {
    customer: (pathId, subRoute) => `/customer/${pathId}/${subRoute || ''}`,
    Main:`main`,
    New: 'new',
    Agreements: `agreements`,
    VonAccounts:`von-accounts`,
    Users: `users`,
    EditUser: (id) => `users/${id}/edit`,
    Collaborations: `collaborations`,
    Discounts: `discounts`,
    VossDiscounts: `voss/discounts`,
    NewVonAccount:  `von-accounts/new`,
    NewVonEmployee: `new-employee`,
    AdministerVonLicenses:  `administer-licenses`,
    Appointments: `appointments`,
    newAppointment: `appointments/new`,
    editAppointment: (appointmentId) => `appointments/${appointmentId}`,
    AdminForms: `admin-forms`,
    Invoices: `invoices`,
    Actions: `customeractions`,
    editSubscription: (subscriptionId) => `subscriptions/${subscriptionId}`,
    Educations: `educations`,
    EducationsCourses: `educations/courses`,
    EducationsOnboardings:`educations/onboardings`,
    EducationsMovies:`educations/movies`,
    EducationsWebinars:`educations/webinars`,
    EducationCode:`educations/education-code`,
    BookEducation: `book`,
    Consulting:`consulting`,
    SendDesktopVersion:`send-desktop-version`,
    Leads:`leads`,
    relatedCustomers:`related-customers`,
    Compensation:`compensation`,
    Campaign:`campaigns`,
    orderNew:`order`,
    orderPlacement:`order-placement`,
    inyettdetails:`inyettdetails`,
    Log :`log`,
    orderConfirmationEmail: (orderId) => `orderconfirmationmail/${orderId}`,
}

export default customerRoutes;